import { Component, Renderer, ElementRef } from '@angular/core';
import { PopoverEditableDropDownComponentBase } from './popover-editable-dropdown.base.component';

@Component({

    selector: 'popover-editable-yes-no-dropdown',
    template: require('./popover-editable-dropdown.base.template.html')
})
export class PopoverEditableYesNoDropdown extends PopoverEditableDropDownComponentBase<string> {
    constructor(protected renderer: Renderer, protected element: ElementRef) {
        super(renderer, element);
    }

    //need to use "0" because the use of if (key) and (0) is false.
    dropdownItems = [{ id: "false", name: "No" }, { id: "true", name: "Yes" }];

    protected getItems(): Promise<string[]> {
        return Promise.resolve<string[]>(this.dropdownItems.map(r => r.id));
    }

    protected mapItem(items: string[], itemToFind: string): string {
        if (itemToFind == null) {
            return "";
        }
        const itemStr = itemToFind.toString();
        const item = items.find(x => x === itemStr);
        return (item + "");
    }

    protected getDisplayValue(itemToFind: string) {
        if (itemToFind == null) {
            return null;
        }
        const itemStr = itemToFind.toString();
        const item = this.dropdownItems.find(x => x.id === itemStr);
        if(item)
            return item.name;
        return null;
    }

    protected getValue(itemToFind: string): any {
        return itemToFind && this.dropdownItems ? this.dropdownItems.find(x => x.id === itemToFind) : null;
    }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/popover-editable-yes-no-dropdown.component.ts